/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { FileStreamResult } from '../models/file-stream-result';
import { GenberegnSagResult } from '../models/genberegn-sag-result';
@Injectable({
  providedIn: 'root',
})
class SagService extends __BaseService {
static readonly submitPath = '/sag/{sagId}/indsend';
static readonly pdfPreviewPath = '/sag/{sagId}/pdfpreview';
static readonly genberegnPath = '/sag/{sagId}/genberegn';
static readonly getProjektIdForSagPath = '/sag/{sagId}/projektid';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param sagId undefined
   * @return Success
   */
  private submitResponse(sagId: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/sag/${encodeURIComponent(String(sagId))}/indsend`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * @param sagId undefined
   * @return Success
   */
  submit(sagId: string): __Observable<string> {
    return this.submitResponse(sagId).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param sagId undefined
   * @return Success
   */
  private pdfPreviewResponse(sagId: string): __Observable<__StrictHttpResponse<FileStreamResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/sag/${encodeURIComponent(String(sagId))}/pdfpreview`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * @param sagId undefined
   * @return Success
   */
  pdfPreview(sagId: string): __Observable<FileStreamResult> {
    return this.pdfPreviewResponse(sagId).pipe(
      __map(_r => _r.body as FileStreamResult)
    );
  }

  /**
   * @param sagId undefined
   * @return Success
   */
  private genberegnResponse(sagId: string): __Observable<__StrictHttpResponse<GenberegnSagResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/sag/${encodeURIComponent(String(sagId))}/genberegn`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GenberegnSagResult>;
      })
    );
  }

  /**
   * @param sagId undefined
   * @return Success
   */
  genberegn(sagId: string): __Observable<GenberegnSagResult> {
    return this.genberegnResponse(sagId).pipe(
      __map(_r => _r.body as GenberegnSagResult)
    );
  }

  /**
   * @param sagId undefined
   * @return Success
   */
  private getProjektIdForSagResponse(sagId: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/sag/${encodeURIComponent(String(sagId))}/projektid`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * @param sagId undefined
   * @return Success
   */
  getProjektIdForSag(sagId: string): __Observable<string> {
    return this.getProjektIdForSagResponse(sagId).pipe(
      __map(_r => _r.body as string)
    );
  }
}

module SagService {
}

export { SagService }
